import React, { useEffect, useState } from "react";
import { Grid, Box, Typography, Avatar, Checkbox } from "@mui/material";
import CustomModal from "../../CustomModal/CustomModal";
import ModalFooter from "../../CustomModal/ModalFooter";
import ModalHeader from "../../CustomModal/ModalHeader";
import SearchComponent from "../../../components/SearchComponent";
import CustomTextField from "../../../components/CustomTextField/CustomTextField";
import CustomDatePicker from "../../../components/CustomDatePicker/CustomDatePicker";
import CustomAutoComplete from "../../../components/CustomAutoComplete/CustomAutoComplete";
import "./TaskDetailsModal.css";
import CompDirection from "../../../themes/CompDirection";
import { fonts } from "../../../themes/themes";
import DropAndSelect from "../../../components/DropAndSelect/DropAndSelect";
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;

  trans?: any;
}

const TaskDetailsModalPresenter = ({
  isModalOpen,
  closeModal,

  trans,
}: ModalProps) => {
  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="75vh"
      modalWidth="40vw"
      overflowY={"auto"}
    >
      <ModalHeader
        modal={{ modal_title: trans("Task Details") }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          spacing={2}
          container
          sx={{
            marginTop: "15px",
          }}
        >
          <Grid item xs={12}>
            <Typography
              style={{
                color: "#757575",
                fontSize: "0.75em",
                fontFamily: fonts.fontFamily,
              }}
            >
              Start Date: 13/01/2023 in list To Do
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Box style={{ display: "flex" }}>
              <Box
                style={{
                  backgroundColor: "#4CAF50",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "5px",
                  width: "20%",
                  height: "auto",
                  borderRadius: "8px",
                  marginTop: "0.5em",
                }}
              >
                <i
                  className="las la-clock"
                  style={{
                    fontFamily: fonts.fontFamily,
                    color: "white",

                    fontSize: "0.725em",
                  }}
                />
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    color: "white",

                    fontSize: "0.725em",
                  }}
                >
                  Mar 25, 2022
                </Typography>
              </Box>
              <Box
                style={{
                  backgroundColor: "#F44336",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "5px",
                  width: "20%",
                  height: "auto",
                  borderRadius: "8px",
                  marginTop: "0.5em",
                  marginLeft: "1em",
                }}
              >
                <i
                  className="las la-clock"
                  style={{
                    fontFamily: fonts.fontFamily,
                    color: "white",

                    fontSize: "0.725em",
                  }}
                />
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    color: "white",

                    fontSize: "0.725em",
                  }}
                >
                  High
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box>
              <CustomTextField
                type="string"
                label="Description"
                multiline={true}
                rows={3}
              />
              <Box marginTop={"1em"} />

              <DropAndSelect
                upload={() => alert()}
                src={""}
                isPDF={false}
                pdfName={""}
                onDelete={() => {
                  alert("");
                  alert(false);
                  alert("");
                }}
              />
              <Typography
                style={{
                  color: " #000000",
                  fontSize: "1em",
                  fontWeight: "bold",
                  fontFamily: fonts.fontFamily,
                  marginTop: "1em",
                }}
              >
                Activity
              </Typography>
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "1em",
                }}
              >
                <Avatar />
                <Box style={{ marginLeft: "1em" }}>
                  <CustomTextField type="string" label="Comment" />
                </Box>
              </Box>
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "1em",
                }}
              >
                <Box>
                  <Avatar />
                </Box>
                <Box style={{ marginLeft: "1em" }}>
                  <Typography style={{ color: "#000000", fontSize: "0.75em" }}>
                    <span style={{ color: "#081735", fontWeight: "bold" }}>
                      Terry Holden
                    </span>
                    Change due date to 25/07/2023
                  </Typography>
                  <Typography style={{ color: "#9E9E9E", fontSize: "0.75em" }}>
                    25/07/2023 - 8:30 AM
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "1em",
                }}
              >
                <Box>
                  <Avatar />
                </Box>
                <Box style={{ marginLeft: "1em" }}>
                  <Typography style={{ color: "#000000", fontSize: "0.75em" }}>
                    <span style={{ color: "#081735", fontWeight: "bold" }}>
                      Terry Holden
                    </span>
                    Change due date to 25/07/2023
                  </Typography>
                  <Typography style={{ color: "#9E9E9E", fontSize: "0.75em" }}>
                    25/07/2023 - 8:30 AM
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "1em",
                }}
              >
                <Box>
                  <Avatar />
                </Box>
                <Box style={{ marginLeft: "1em" }}>
                  <Typography style={{ color: "#000000", fontSize: "0.75em" }}>
                    <span style={{ color: "#081735", fontWeight: "bold" }}>
                      Terry Holden
                    </span>
                    Change due date to 25/07/2023
                  </Typography>
                  <Typography style={{ color: "#9E9E9E", fontSize: "0.75em" }}>
                    25/07/2023 - 8:30 AM
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box
              style={{
                border: "1px solid #0000001F",
                padding: "1em",
                borderRadius: "7px",
              }}
            >
              <Typography
                style={{
                  color: "#575757",
                  fontFamily: fonts.fontFamily,
                  fontSize: "0.725em",
                  fontWeight: "bold",
                }}
              >
                Members(2)
              </Typography>
              <Box marginTop={"1em"} />
              <Box style={{ display: "flex" }}>
                <Avatar />
                <Avatar />
                <Box className="add_btn_perf" onClick={() => console.log()}>
                  {" "}
                  <i className="las la-plus" style={{ color: "white" }} />{" "}
                </Box>
              </Box>
              <Box marginTop={"1em"} />
              <CustomDatePicker label="Start From" />
              <Box marginTop={"1em"} />
              <CustomDatePicker label="Due Date" />
              <Box marginTop={"1em"} />
              <CustomAutoComplete label="Set Priority" value="Low" />
            </Box>
          </Grid>
        </Grid>
      </CompDirection>

      <Box style={{ marginTop: "35px" }} />
      <ModalFooter
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default TaskDetailsModalPresenter;
